import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { Application } from '../../../models/admin-models';
import { AdminService } from '../../admin.service';
import { saveAs } from '@progress/kendo-file-saver';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-custom-report-req',
  templateUrl: './custom-report-req.component.html',
  styleUrls: ['../toolbox.component.scss'],
  imports: [
    MatSelectModule,
    MatRadioModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class CustomReportReqComponent {
  private admnSrvc = inject(AdminService);

  @Input() applications: Application[];
  @Output() toggleLoading = new EventEmitter();
  customReportDownloadApp: string;
  customReportDownloadType = 'text/html';
  customReportInput: string;
  customReportStatus: string;
  customReportStatusClass: string;

  customReportRequest() {
    this.toggleLoading.emit();
    this.customReportStatus = null;
    this.customReportStatusClass = null;

    const fileType = this.customReportDownloadType.split('/')[1];

    const data = {
      type: this.customReportDownloadType,
      app: this.customReportDownloadApp,
      payload: `${this.customReportInput}`,
    };

    this.admnSrvc.customReport(data).subscribe({
      next: res => {
        this.toggleLoading.emit();
        let fileData;
        const filename = `custom-report.${fileType}`;
        const reader = new FileReader();
        reader.readAsDataURL(res);

        reader.onloadend = () => {
          fileData = reader.result;
          saveAs(fileData, filename);
        };
      },
      error: catchError(err => {
        this.toggleLoading.emit();
        this.customReportStatus = err;
        this.customReportStatusClass = 'failure';
        return throwError(() => err.error || 'Server error');
      }),
    });
  }
}
